var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 44,
    viewBox: "0 0 74 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4741 36.2291H58.8254L61.1588 43.2907H73.8697L58.15 0H44.2724L36.8984 20.2282L29.6587 0.290703H15.7811L0 43.5814H12.6495L14.9829 36.5198H30.3342L30.6315 37.4196L28.4912 43.2907H32.5715L32.6676 43.5814H45.3785L43.1094 37.3327L43.4741 36.2291ZM43.1094 37.3327L36.8984 20.2282L30.6315 37.4196L32.5715 43.2907H41.1407L43.1094 37.3327ZM51.1498 13.0179L55.8166 27.0183H46.5444L51.1498 13.0179ZM22.6585 13.3086L27.3253 27.309H18.0531L22.6585 13.3086Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2469 36.0887H35.6339L35.2367 37.2906H33.0836L35.7698 29.922H38.1319L40.8076 37.2906H38.6441L38.2469 36.0887ZM37.7347 34.5209L36.9404 32.1378L36.1565 34.5209H37.7347Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7c45a04d5f23a153aa7fc5ee7252f7e5.svg";
export { ForwardRef as ReactComponent };